import { haptic } from "@/lib/haptic";
import React from "react";

interface NavButtonProps {
  isActive: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  fillIcon: React.ReactNode;
  text: string;
  className?: string;
}

const NavButton: React.FC<NavButtonProps> = ({
  isActive,
  onClick,
  icon,
  fillIcon,
  text,
  className,
}) => {
  const handleClick = () => {
    haptic.soft();
    onClick();
  };
  return (
    <button
      onClick={handleClick}
      className={`aspect-square rounded-lg z-20 ${
        isActive ? "text-black" : "text-[var(--grey-light)]"
      } ${className}`}
    >
      <div
        className={`flex flex-col items-center justify-center gap-1 w-full px-[8px] pt-[2px]`}
      >
        <div className="h-[26px] w-[26px]">{isActive ? fillIcon : icon}</div>
        <p className="text-xs">{text}</p>
      </div>
    </button>
  );
};

export default NavButton;
